import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const BERLIN = 'Europe/Berlin';

/** Whether the instant lies on a Berlin calendar day before the day of `now`. */
// @ai-generated 2026-10-23T13:20:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function isBeforeTodayInBerlin(instantIso: string, now: Date = new Date()): boolean {
    const instant = dayjs(instantIso);
    return instant.isValid() && instant.tz(BERLIN).isBefore(dayjs(now).tz(BERLIN), 'day');
}
